import { Provider } from '@angular/core';
import { provideRoutes } from 'routing-util';
import { defaultQuotesFeatureRoutesConfig, QuotesFeatureRoutesConfig } from './QuotesFeatureRoutesConfig';

export function provideQuotesFeatureRoutes(config?: Partial<QuotesFeatureRoutesConfig>): Provider {
  const useConfig = { ...defaultQuotesFeatureRoutesConfig, ...config };
  return [
    provideRoutes([
      {
        path: useConfig.path,
        loadChildren: () => import('feature-quotes').then((m) => m.quoteRoutes),
      },
      {
        path: useConfig.path,
        loadChildren: () => import('./routes/routes').then((m) => m.routes),
      },
    ]),
  ];
}
